export interface AlainPageHeaderConfig {
  /**
   * é¦é¡µææ¬ï¼è¥æå®ç©ºè¡¨ç¤ºä¸æ¾ç¤ºï¼é»è®¤ï¼`é¦é¡µ`
   */
  home?: string;
  /**
   * é¦é¡µé¾æ¥ï¼é»è®¤ï¼`/`
   */
  homeLink?: string;
  /**
   * é¦é¡µé¾æ¥å½éååæ°
   */
  homeI18n?: string;
  /**
   * èªå¨çæå¯¼èªï¼ä»¥å½åè·¯ç±ä»ä¸»èåä¸­å®ä½ï¼é»è®¤ï¼`true`
   */
  autoBreadcrumb?: boolean;
  /**
   * èªå¨åä¸éå½æ¥æ¾ï¼é»è®¤ï¼`false`
   *  - èåæ°æ®æºåå« `/ware`ï¼å `/ware/1` ä¹è§ä¸º `/ware` é¡¹
   */
  recursiveBreadcrumb?: boolean;
  /**
   * èªå¨çææ é¢ï¼ä»¥å½åè·¯ç±ä»ä¸»èåä¸­å®ä½ï¼é»è®¤ï¼`true`
   */
  autoTitle?: boolean;
  /**
   * æ¯å¦èªå¨å°æ åä¿¡æ¯åæ­¥è³ `TitleService`ã`ReuseService` ä¸ï¼é»è®¤ï¼`true`
   */
  syncTitle?: boolean;
  /**
   * æ¯å¦åºå®æ¨¡å¼ï¼é»è®¤ï¼`false`
   */
  fixed?: boolean;
  /**
   * åºå®åç§»å¼ï¼é»è®¤ï¼`64`
   */
  fixedOffsetTop?: number;
}
